// @ts-nocheck
/* eslint-disable */
import {
  HlxButton,
  UptimeGeneralDialog,
  UptimeMarketPlace,
  UptimeTopNav,
  UptimeTextbox,
  UptimeOnBehalfIndicator,
} from '@uptime/uptime-component';
import PunchOutModal from 'components/PunchOutModal';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import {
  AutomatedServiceRequestPath,
  CustomDashboardPagePath,
  ExperienceCustomDashboardPath,
  GetSupportPath,
  GlobalSearchPath,
  HomePath,
  ShoppingCartPath
} from 'utils/routes';
import useDevice, { Device } from 'utils/useDevice';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box } from '@mui/material';
import ClockAlertOutline from 'assets/images/topNav/clock-alert-outline.svg';
import { openChat } from 'components/ConnectChatWidget';
import { LanguageCode } from 'components/LanguageSelector';
import { msalInstance } from 'config/auth';
import { oktaAuth } from 'config/oktaAuth';
import { CONFIG } from 'constants/configConstants';
import {
  LANGUAGE_KEY,
  PORTAL_NAME,
  PORTAL_VERSION,
} from 'constants/index';
import { MARKETPLACE_CATEGORY_URL } from 'constants/marketplaceConstants';
import { useMarketplaceProvider } from 'containers/MarketplaceContainer';
import MarketplaceThemeProvider from 'containers/MarketplaceThemeProvider';
import { useUserData } from 'hooks';
import parse from 'html-react-parser';
import { Catalog, MarketplaceGroupings, MenuItem, UserPreferences } from 'models';
import {
  SearchParamsType,
  firstPage,
  relevance,
  view,
} from 'pages/GetSupportSearchPage/SearchConfig';
import useNewJoinerOrderTask from 'pages/OnboardingPage/hooks/useNewJoinerOrderTask';
import queryString from 'query-string';
import { useIdleTimer } from 'react-idle-timer';
import SupportSearchAction from 'redux/actions/supportSearchAction';
import ConfigAction from 'redux/actions/configAction';
import BaseAction from 'redux/actions/baseAction';
import { RootState } from 'redux/store';
import AppService from 'services/app.service';
import { checkEnabledFeature, getKeyFeaturesConfig, handleCheckLastDate } from 'utils/function';
import { GenerateDataTranslation } from 'utils/translation';
import useBreakpoint, { Breakpoint } from 'utils/useBreakpoint';
import ActOnBehalfModal from './ActOnBehalfModal';
import MobileNavMenu from './MobileNavMenu/index';
import Notification from './Notification';
import {
  ActionsContainer,
  StyleOutageNotification,
  StyledBadge,
  StyledCart,
  StyledDialogContent,
  StyledTopnavWrapper,
} from './TopNav.style';
import UserSection from './UserSection/index';
import {
  useAppInsightsContext,
  useTrackEvent
} from '@microsoft/applicationinsights-react-js';
import useManageMyTeams from 'hooks/useManageMyTeams';
import useFeatureFlags from 'pages/HomePage/hooks/useFeatureFlags';
import { signOut } from 'config/oidcAuth';
import OnBehalfIndicator from 'components/OnBehalfIndicator';
import useAutomatedServiceRequest from 'hooks/useAutomatedServiceRequest';
import useGlobalSeachFlags from 'pages/GlobalSearchPage/hooks/useGlobalSeachFlags';

interface TopNavProps {
  isAuthenticated: boolean;
  isNewJoiner: boolean;
  isNewJoinerLoading: boolean;
  isLastWorkingDay: boolean;
  oidcAuthen: any;
  isBeforeStartAccessDate?: boolean;
}

const clockAlertOutlineIcon = ClockAlertOutline;

const MENU_KEY = {
  APPROVALS: 'approvals',
  MY_TECHNOLOGY: 'myTechnology',
  REGISTER_DEVICE: 'registerDevice',
  RETURN_UNKNOWN_DEVICE: 'returnUnknownDevice',
  CHAT_WITH_EVA: 'chatWithEVA',
  DXC_GEAR: 'dxcGear',
  COMPUTERS: 'computers',
  VIRTUAL_APPLICATIONS: 'virtualApplications',
  VIRTUAL_MACHINE: 'virtualMachine',
  MARKETPLACE_SERVICES: 'marketplace.services',
  ADD_CUSTOM_DASHBOARD: 'addCustomDashboard',
  ADD_CUSTOM_DASHBOARD_EXPERIENCE: 'addCustomDashboardExperience',
  POWER_BI: 'featureItems.operation',
  EXPERIENCE: 'featureItems.experience',
  ADD_CUSTOM_DASHBOARD_KEY: 'featureItems.addCustomDashboard',
  ADD_CUSTOM_DASHBOARD_EXPERIENCE_KEY: 'featureItems.addCustomDashboardExperience',
};

const mapCatalogsToMenuItems = (catalogs: Catalog[] = []) => {
  return catalogs.map(item => ({
    enabled: item.active,
    url: AutomatedServiceRequestPath.replace(':title', item.title),
    name: item.title,
    key: item.id,
    items: [],
  }));
};

const TopNav: React.FC<TopNavProps> = ({
  isAuthenticated,
  isNewJoiner,
  isNewJoinerLoading,
  isLastWorkingDay,
  oidcAuthen,
  isBeforeStartAccessDate
}) => {
  const { isMarketplaceEnabled } = useMarketplaceProvider();
  const { isOrderAllowed } = useNewJoinerOrderTask();
  const [isMobileNavMenuOpen, setIsMobileNavMenuOpen] = useState(false);
  const [isPunchOutModalOpen, setIsPunchOutModalOpen] = useState(false);
  const [punchOutModalContent, setPunchOutModalContent] = useState({
    message: '',
    url: '',
  });
  const [isIdlePrompt, setIsIdlePrompt] = useState(false);
  const [countdownTimer, setCountdownTimer] = useState(120);
  const [intervalHandler, setIntervalHandler] = useState(null);
  const [promptTimeOut, setPromptTimeOut] = useState(120);
  const [inActivityTimeOut, setInActivityTimeOut] = useState(7200);
  const [subMenuItems, setSubMenuItems] = useState<Record<string, MenuItem>>(
    {},
  );
  const [isOpenModalActOnBehalf, setIsOpenModalActOnBehalf] = useState(false);
  const [isManageMyTeam, setIsManageMyTeam] = useState(false);

  const [dashboardConfig, setDashboardConfig] = useState([]);
  const [openAddCustomDashboardDialog, setOpenAddCustomDashboardDialog] = useState(false);
  const [customDashboardSubmenuFrom, setCustomDashboardSubmenuFrom] = useState('');
  const [customDashboardName, setCustomDashboardName] = useState("");
  const [customDashboardUrl, setCustomDashboardUrl] = useState("");
  const [customDashboardFormError, setCustomDashboardFormError] = useState<{
    name?: boolean;
    url?: boolean;
  }>({name: false, url: false});
  const dashboardStorage : any = JSON.parse(localStorage.getItem('DASHBOARD') || '[]');
  const dashboardExperienceStorage : any = JSON.parse(localStorage.getItem('DASHBOARD_EXPERIENCE') || '[]');

  const location = useLocation();

  const { isOnBehalf, isOnBehalfNewJoiner, pcOrderOBO, isOnBehalfLeaver } = useSelector(state => state.onBehalfReducer);
  const { isOnBehalf: isPcOderOnBehalf, userOnBehalf } = pcOrderOBO;
  const { category, cart, user: marketplaceUser } = useSelector(
    (state: RootState) => state.marketplaceReducer,
  );
  const isSupportCountry = marketplaceUser?.is_supported_country;
  const configReducer = useSelector(state => state.configReducer);
  let { permission, isLoadingConfig, generalConfig, navMenuConfig } = configReducer;
  const { menu: navConfig, stickyMenu, homeIcon } = navMenuConfig;
  const isLeaverEnabled = generalConfig?.leaver?.isLeaverEnabled;
  const { isGlobalSearchEnabled} = useGlobalSeachFlags();

  const userPreferences = useSelector(
    ({ userPreferencesReducer }) =>
      userPreferencesReducer.userPreferences as UserPreferences,
  );
  const userLanguage = userPreferences.preferences?.language;
  const localLanguage = localStorage.getItem(LANGUAGE_KEY);
  const languageCode = (localLanguage || userLanguage || 'en') as LanguageCode;

  const isMarketplace = location.pathname.includes('marketplace')
    ? true
    : false;
  const { t } = useTranslation(['topNav','common','home-accessibility']);
  const breakpoint = useBreakpoint();
  const device = useDevice();
  const history = useHistory();
  const dispatch = useDispatch();
  const dataUser = useUserData();

  const { listCatalog } = useAutomatedServiceRequest();

  // Handle Global Search Props
  let { q: urlKeywords, order_by: orderByUrl = view.value } = queryString.parse(
    location.search,
  );
  const [orderBy, setOrderBy] = useState<string>(orderByUrl);
  const keywords = typeof urlKeywords === 'string' ? urlKeywords : '';

  const { pcManagement, knowledge, timeOutSession, dashboard, icServiceRequest } = permission;

  const isCheckDashboardEnabled = dashboard?.enabled || false;

  const getMarketPlace = getKeyFeaturesConfig(
    pcManagement?.features,
    CONFIG.PC_MANAGEMENT.MARKET_PLACE,
  );
  const isCheckMarketPlace =
    pcManagement?.enabled && checkEnabledFeature(getMarketPlace);

  const getAnalytics = getKeyFeaturesConfig(
    pcManagement?.features,
    CONFIG.PC_MANAGEMENT.ANALYTICS_CONFIG,
  );
  const isCheckAnalytics =
    pcManagement?.enabled && checkEnabledFeature(getAnalytics);

  const getTopKnowledgeArticles = getKeyFeaturesConfig(
    knowledge?.features,
    CONFIG.KNOWLEDGE.TOP_KNOWLEDGE_ARTICLES,
  );
  const isCheckTopKnowledgeArticles =
    knowledge?.enabled && checkEnabledFeature(getTopKnowledgeArticles);

  const getManage = getKeyFeaturesConfig(
    pcManagement?.features,
    CONFIG.PC_MANAGEMENT.MANAGE,
  );
  const isCheckManage = pcManagement?.enabled && checkEnabledFeature(getManage);

  const { isManageMyTeam: isCheckGroupDeviceManagers } = useManageMyTeams();

  const { isIcServiceRequestEnabled } = useFeatureFlags({icServiceRequest});
  const isAuthenticatedByOidc = AppService.isAuthenticatedByOidc();

  useEffect(() => {
    setPromptTimeOut(generalConfig?.promptTimeOut);
    setInActivityTimeOut(generalConfig?.userInActivity);
  }, [generalConfig?.promptTimeOut, generalConfig?.userInActivity]);

  useEffect(() => {
    if (isNewJoinerLoading) return;

    const isLastWorkingDayAbo = !!isLeaverEnabled && !!isOnBehalfLeaver && handleCheckLastDate(dataUser, 'last_working_date');
    if (!isOrderAllowed || isLastWorkingDay || isLastWorkingDayAbo || isBeforeStartAccessDate) {
      setSubMenuItems({});
      return;
    }

    const configKey = isOnBehalf
      ? (isOnBehalfNewJoiner ? [CONFIG.NAV_NEW_JOINER_MENU.KEY, CONFIG.NAV_NEW_JOINER_MENU.LABEL] : [CONFIG.NAV_MENU_ABO.KEY, CONFIG.NAV_MENU_ABO.LABEL])
      : isNewJoiner
      ? [CONFIG.NAV_NEW_JOINER_MENU.KEY, CONFIG.NAV_NEW_JOINER_MENU.LABEL]
      : [CONFIG.NAV_MENU.KEY, CONFIG.NAV_MENU.LABEL];

    if(!dataUser?.lockedOut) {
      dispatch(ConfigAction.getNavMenuConfig(configKey[0], configKey[1]));
    }
    if(isCheckDashboardEnabled){
      AppService.getValueConfigAzure(CONFIG.UPTIME_DASHBOARD.KEY, CONFIG.UPTIME_DASHBOARD.LABEL).then((data:any) => {
        setDashboardConfig(data || [])
      });
    }
  }, [isOnBehalf, isNewJoinerLoading, isOrderAllowed, isOnBehalfNewJoiner, isBeforeStartAccessDate, isOnBehalfLeaver]);

  useEffect(() => {
    setIsManageMyTeam(isCheckGroupDeviceManagers && dataUser?.isManager);
  }, [isCheckGroupDeviceManagers, dataUser?.isManager]);

  const topNav = GenerateDataTranslation('topNav');
  const homeAccessibilityTranslation = GenerateDataTranslation('home-accessibility');

  useEffect(() => {
    if (navConfig && Object.keys(navConfig).length > 0 && !isLoadingConfig) {
      const config = JSON.parse(JSON.stringify(navConfig));
      for (const key in config) {
        const groupItems = (config[key].items = mappingNavConfig(
          config[key].items,
        ));
        groupItems.map((groupItem: any) => {
          groupItem?.items.find((item: any) => {
            item?.items?.map((itemLv2: any) => {
              return itemLv2;
            });
            return item;
          });
        });
      }
      setSubMenuItems(config);
    }
  }, [navConfig, topNav, isOnBehalf, isLoadingConfig]);

  const mappingNavConfig = (items = [], level = 1) => {
    if (items.length === 0) return [];
    return items.map(item => ({
      ...item,
      name: getI18nValue(item.key, item.name),
      items: mappingNavConfig(item.items, level + 1),
    }));
  };

  const getI18nValue = (key, value) => {
    const splits: string[] = key.split('.');
    const firstString = splits?.[0];
    const lastString = splits?.[1];
    const hasFeatureItem = firstString === 'featureItems';
    const i18nValue =
      (hasFeatureItem ? topNav?.[firstString]?.[lastString] : topNav?.[key]) ||
      value;
    return i18nValue as string;
  };

  // Shared props for the RequestNavMenuItem components and Get Support actions
  const sharedProps = {
    closeMobileNavMenu: () => setIsMobileNavMenuOpen(false),
    openPunchOutModal: () => setIsPunchOutModalOpen(true),
    setPunchOutModalContent: setPunchOutModalContent,
  };

  const mapMarketplaceMenuItems = (
    groupings: MarketplaceGroupings = [],
    initUrl = MARKETPLACE_CATEGORY_URL,
    initKey = 'marketplace',
  ): MenuItem[] => {
    if (groupings.length === 0) return [];
    return groupings?.map(group => {
        const groupUrl = `${initUrl}/${group.name}`;
        const formattedName = group.name
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-');
        const key = `${initKey}.${formattedName}`;

        const overrideLang = group.lang_overrides;
        let itemName =
          overrideLang?.[languageCode]?.name ||
          getI18nValue(key, group.name);
        return {
          key: key,
          name: itemName || group.name,
          url: groupUrl,
          enabled: true,
          items: mapMarketplaceMenuItems(group.children, groupUrl, key),
        } as MenuItem;
      });
  };

  const filterMarketplaceMenuItems = (menuItems: MenuItem[]) => {
    const disabledCategories = subMenuItems?.marketplace?.disabledCategories || [];
    return menuItems
      .map(item => {
        const enabled = !disabledCategories.includes(item.key);
        const items = enabled
          ? filterMarketplaceMenuItems(item.items || [])
          : [];
        return { ...item, enabled, items };
      })
      .filter(item => !!item.enabled);
  };

  const marketplaceCategories = useMemo(() => mapMarketplaceMenuItems(category || []), [category, languageCode]);

  const filteredSubMenuMarketplace = useMemo(() => {
    const marketplaceItems = subMenuItems?.marketplace?.items ?? [];
    const filteredCategories = filterMarketplaceMenuItems(marketplaceCategories);
    const menuItems = [...filteredCategories, ...marketplaceItems];
    const itemsObj = menuItems.reduce((itemsObj, item) => {
      if(!item.enabled) return itemsObj;
      const existedItem = itemsObj[item.key] || { items: [] };
      itemsObj[item.key] = {
        ...item,
        ...existedItem,
        items: [...existedItem.items, ...item.items],
      };
      return itemsObj;
    }, {} as Record<string, MenuItem>);

    return Object.values(itemsObj);
  }, [subMenuItems?.marketplace, marketplaceCategories]);

  const filteredSubMenuServices = useMemo(() => {
    return mapCatalogsToMenuItems(listCatalog);
  }, [listCatalog]);

  const enabledMapping: Record<string, boolean | undefined> = {
    'featureItems.myTeam': isManageMyTeam,
    'featureItems.onboarding': !!generalConfig?.newJoiner?.isNewJoinerAllowed,
    'featureItems.offboarding': !!generalConfig?.leaver?.isLeaverEnabled,
    'featureItems.manageOnboarding': !!generalConfig?.newJoiner?.isNewJoinerAllowed,
    'featureItems.myOrders': isMarketplaceEnabled && isSupportCountry,
    'featureItems.icServiceRequest': isIcServiceRequestEnabled
  };

  const filterEnabledItems = (items: MenuItem[]): MenuItem[] => {
    if (items.length === 0) return [];
    return items
    .map(item => {
      const config = dashboardConfig?.filter((config) => config.permission && config?.url === item?.url)[0];
      const enabled = config && dataUser ? config.permission.includes(dataUser.role) : item.enabled && enabledMapping[item.key] !== false;
      
      if(item.key === MENU_KEY.POWER_BI) {
        const customDashboardConfig = dashboardStorage?.filter((config) => config.name) || [];
        const mappingCustomDashboardNav = customDashboardConfig.length > 0 ? customDashboardConfig.map((item) => ({
          "url": item.url,
          "enabled": true,
          "name": item.name.split(/\s+/).map((c) => `${c[0].toUpperCase()}${c.slice(1).toLowerCase()}`).join(' '),
          "key": item.name.replace(/\s+/g,""),
        })) : [];

        const addCustomDashboardNav = item.items?.filter((i:any) => i.key === MENU_KEY.ADD_CUSTOM_DASHBOARD_KEY) || [];
        const restDashboardNav = item.items?.filter((i:any) => i.key !== MENU_KEY.ADD_CUSTOM_DASHBOARD_KEY) || [];

        const customItems = (addCustomDashboardNav.length > 0 && addCustomDashboardNav[0]?.enabled)
        ? restDashboardNav.concat(mappingCustomDashboardNav).concat(addCustomDashboardNav)
        : restDashboardNav.concat(mappingCustomDashboardNav);

        return {
          ...item,
          enabled,
          items: enabled ? filterEnabledItems(customItems || []) : []
        }
      }else if(item.key === MENU_KEY.EXPERIENCE) {
        const customDashboardConfig = dashboardExperienceStorage?.filter((config) => config.name) || [];
        const mappingCustomDashboardNav = customDashboardConfig.length > 0 ? customDashboardConfig.map((item) => ({
          "url": item.url,
          "enabled": true,
          "name": item.name.split(/\s+/).map((c) => `${c[0].toUpperCase()}${c.slice(1).toLowerCase()}`).join(' '),
          "key": item.name.replace(/\s+/g,""),
        })) : [];

        const addCustomDashboardNav = item.items?.filter((i:any) => i.key === MENU_KEY.ADD_CUSTOM_DASHBOARD_EXPERIENCE_KEY) || [];
        const restDashboardNav = item.items?.filter((i:any) => i.key !== MENU_KEY.ADD_CUSTOM_DASHBOARD_EXPERIENCE_KEY) || [];

        const customItems = (addCustomDashboardNav.length > 0 && addCustomDashboardNav[0]?.enabled)
        ? restDashboardNav.concat(mappingCustomDashboardNav).concat(addCustomDashboardNav)
        : restDashboardNav.concat(mappingCustomDashboardNav);

        return {
          ...item,
          enabled,
          items: enabled ? filterEnabledItems(customItems || []) : []
        }
      }else{
        return {
          ...item,
          enabled,
          items: enabled ? filterEnabledItems(item.items || []) : [],
        };
      }
      })
      .filter(item => !!item.enabled);
  };

  const menuItems = Object.values(subMenuItems)
    .map(menuItem => {
      const enabledMenus: Record<string, boolean> = {
        marketplace: isCheckMarketPlace,
        manage: isCheckManage,
        support: isCheckTopKnowledgeArticles,
        analytics: isCheckAnalytics,
        'featureItems.panel': isCheckDashboardEnabled,
      };
      const filteredSubMenus: Record<string, MenuItem[]> = {
        marketplace: filteredSubMenuMarketplace,
        services: filteredSubMenuServices,
      };

      const items = filteredSubMenus[menuItem?.key] || menuItem.items || [];

      return {
        ...menuItem,
        name: menuItem?.name || topNav?.[menuItem?.key] || '',
        enabled: menuItem.enabled && enabledMenus[menuItem?.key] !== false,
        items: filterEnabledItems(items),
        showDivider: false,
      };
    })
    .filter(item => item.enabled)
    .sort((a, b) => (a?.order || 0) - (b?.order || 0));

  const closeNavMenu = () => {
    isMobileNavMenuOpen && setIsMobileNavMenuOpen(!isMobileNavMenuOpen);
  };

  // Handle tracking menu item clicked
  const appInsights = useAppInsightsContext();
  const trackClickMenuItemEvent = useTrackEvent<any>(
    appInsights,
    `The global navigation menu item clicked`,
    menuItems
  );
  // Handle tracking global search keywords input
  const trackGlobalSearchInput = useTrackEvent<any>(
    appInsights,
    'Global search keywords input',
    keywords,
  );

  const onItemClick = item => {
    trackClickMenuItemEvent({menuItems: item?.name ? item?.name : 'Unknown item'});
    if (item.function) {
      switch (item.function) {
        case MENU_KEY.CHAT_WITH_EVA:
          openChat();
          closeNavMenu();
          break;
        case MENU_KEY.ADD_CUSTOM_DASHBOARD:
          setOpenAddCustomDashboardDialog(true);
          setCustomDashboardSubmenuFrom('dashboard');
          closeNavMenu();
          break;    
        case MENU_KEY.ADD_CUSTOM_DASHBOARD_EXPERIENCE:
          setOpenAddCustomDashboardDialog(true);
          setCustomDashboardSubmenuFrom('experience');
          closeNavMenu();
          break;        
        default:
          break;
      }
    } else {
      const path = item.url || '';
      if (item.openURLnewtab) {
        window.open(path, '_blank');
        closeNavMenu();
      } else if (!!path) {
        history.push(path);
        closeNavMenu();
      }
    }
  };

  const onMenuClick = (e: any, active?: string) => {
    let path = '';
    if (e.url && e.hasLandingPage && e.key !== active) {
      path = e.url;
    } else if (e && e.portalFeaturePath) {
      path = e.portalFeaturePath;
    }

    if (
      window.innerWidth >= 1280 ||
      device === Device.Desktop ||
      device === Device.Ultrawide
    ) {
      if (path) {
        history.push(path);
      }
    } else {
      setIsMobileNavMenuOpen(!isMobileNavMenuOpen);
    }
  };

  const onPrompt = () => {
    // Fire a Modal Prompt
    if (timeOutSession?.enabled) {
      setIsIdlePrompt(true);
      setCountdownTimer(promptTimeOut);
      let interval = setInterval(() => {
        setCountdownTimer(prevCount => prevCount - 1);
      }, 1000);
      setIntervalHandler(interval);
    }
  };

  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    if (timeOutSession?.enabled) {
      clearInterval(intervalHandler);
      setIsIdlePrompt(false);
      handleLogout();
    }
  };

  const onActive = event => {
    // Close Modal Prompt
    // Do some active action
    if (timeOutSession?.enabled) {
      setIsIdlePrompt(false);
      clearInterval(intervalHandler);
      idleTimer.reset();
    }
  };

  const handleLogout = () => {
    if(isAuthenticatedByOidc){
      signOut();
    }
    else{
      if (!oktaAuth) return;
      AppService.isAuthenticatedByAzure()
      ? msalInstance.logoutRedirect().catch(e => {
          console.error(e);
        })
      : oktaAuth.signOut();    
    }

    const currentVersion = localStorage.getItem(PORTAL_VERSION);
    localStorage.clear();
    localStorage.setItem(PORTAL_VERSION, currentVersion);
  };

  const handleSubmitCustomDashboard = () => {
    const newDashboardName = !customDashboardName
      .toLowerCase()
      .includes(' dashboard')
      ? customDashboardName.trim() + ' dashboard'
      : customDashboardName.trim();
    const newDashboardUrl = `${customDashboardSubmenuFrom === 'experience' ? ExperienceCustomDashboardPath : CustomDashboardPagePath}/${newDashboardName}`;
    const newCustomDashboardConfig = {
      url: newDashboardUrl,
      name: newDashboardName,
      charts: [
        {
          embedUrl: customDashboardUrl,
        },
      ],
    };
    let tempDashboardStorage = '';
    if(customDashboardSubmenuFrom === 'experience'){
      tempDashboardStorage = JSON.stringify([
        ...dashboardExperienceStorage,
        newCustomDashboardConfig,
      ]);
    }
    else {
      tempDashboardStorage = JSON.stringify([
        ...dashboardStorage,
        newCustomDashboardConfig,
      ]);
    }
    if (!!customDashboardName && !!customDashboardUrl) {
      localStorage.setItem(customDashboardSubmenuFrom === 'experience'? 'DASHBOARD_EXPERIENCE' :'DASHBOARD', tempDashboardStorage);
      history.push(newDashboardUrl);
      setOpenAddCustomDashboardDialog(false);
      setCustomDashboardSubmenuFrom('');
      setCustomDashboardName('');
      setCustomDashboardUrl('');
    }else{
      if (!customDashboardName) {
        setCustomDashboardFormError((prev) => ({...prev, name:true}));
      }
      if (!customDashboardUrl) {
        setCustomDashboardFormError((prev) => ({...prev, url:true}));
      }
    }
  };

  const handleOpenSubmenu = (isOpen: boolean) => {
    dispatch(BaseAction.setIsOpenSubmenu(isOpen));
  };

  const buttonsAction = (
    <ActionsContainer>
      <div className="spacing-button">
        <HlxButton
          variant="outlined"
          label={t('topNav:signOut')}
          onClick={handleLogout}
        ></HlxButton>
      </div>
      <HlxButton
        variant="contained"
        label={t('topNav:confirmationSession.cancelLabel')}
        onClick={onActive}
      ></HlxButton>
    </ActionsContainer>
  );
  const customeDashboardButtonsAction = (
    <ActionsContainer>
      <div className="spacing-button">
        <HlxButton
          variant="outlined"
          label={t('common:cancel')}
          onClick={() => {
            setOpenAddCustomDashboardDialog(false);
            setCustomDashboardName('');
            setCustomDashboardSubmenuFrom('');
            setCustomDashboardUrl('');
            setCustomDashboardFormError({ name: false, url: false });
          }}
        ></HlxButton>
      </div>
      <HlxButton
        variant="contained"
        label={t('common:submit')}
        onClick={handleSubmitCustomDashboard}
      ></HlxButton>
    </ActionsContainer>
  );

  const renderIndicator = () => {
    if (isOnBehalf) {
      return <OnBehalfIndicator />;
    }
    if (isPcOderOnBehalf) {
      return (
        <UptimeOnBehalfIndicator
          title={t('pcOrder:onBehalfOf.title', {
            name: userOnBehalf?.name,
            email: userOnBehalf?.email,
          })}
          showCloseButton={false}
          fullWidth={false}
        />
      );
    }
    return <></>;
  };

  const idleTimer = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    promptTimeout: 1000 * promptTimeOut,
    timeout: 1000 * inActivityTimeOut,
    crossTab: true,
    syncTimers: 1000 * 60,
  });
  let minutesAndSeconds =
    countdownTimer > 60
      ? `${t('topNav:confirmationSession.minutes')}`
      : `${t('topNav:confirmationSession.seconds')}`;
  let resultCountDown =
    countdownTimer > 60 ? Math.ceil(countdownTimer / 60) : countdownTimer;

  const continueText = t('topNav:confirmationSession.cancelLabel');
  const signOutText = t('topNav:signOutUppercase');

  const knowledgeSearchPlaceHolder = t('topNav:knowledgeSearchPlaceHolder');
  const globalSearchPlaceHolder = t('topNav:globalSearchPlaceHolder');

  // Handle Global Search Function
  const getSearchParams = ({
    page = firstPage,
    textSearch = keywords,
    order_by = orderBy ?? orderByUrl,
    options = {},
  }: SearchParamsType) => {
    const query = queryString.stringify(
      {
        q: textSearch,
        order_by: order_by,
        page,
      },
      { ...options },
    );
    return query;
  };

  const updateSearchUrl = (params?: SearchParamsType = {}): void => {
    const query = getSearchParams({
      options: { arrayFormat: 'separator' },
      ...params,
    });
    history.replace(`${GetSupportPath}?${query}`);
  };

  const handleKBSearch = (value: string) => {
    if (isGlobalSearchEnabled && value !== keywords) {
      if (!value) return;
      const query = queryString.stringify({
        q: value,
        filter: "all"
      });
      history.push(`${GlobalSearchPath}?${query}`);
      return;
    };

    if (value !== keywords) {
      dispatch(SupportSearchAction.setKnowledgeBase([]));
      dispatch(SupportSearchAction.setCategory([]));
      dispatch(
        SupportSearchAction.getKnowledgeBaseAndCategoryFilterSuccess({
          knowledge_base: [],
          category_tree: [],
        }),
      );
      setOrderBy(!!value ? relevance.value : view.value);
      updateSearchUrl({
        textSearch: value,
        order_by: !!value ? relevance.value : view.value,
      });
    }
  };

  const pushToHistory = (keywords: string) => {
    if (isGlobalSearchEnabled && keywords) {
      const query = queryString.stringify({
        q: keywords,
        filter: "all"
      });
      history.push(`${GlobalSearchPath}?${query}`);
      return;
    };

    if (!isGlobalSearchEnabled && keywords) {
      const query = queryString.stringify({
        q: keywords,
        order_by: relevance.value,
      });
      trackGlobalSearchInput({ keywords: keywords.trim() === '' ? 'Blank space' : keywords });
      setTimeout(() => {
        history.push(`${GetSupportPath}?${query}`);
      }, 50);
    }
  };
  return (
    <MarketplaceThemeProvider>
      <StyledTopnavWrapper
        searchBarPostion={generalConfig?.topNav?.searchBarPostion}
      >
      <ActOnBehalfModal
        isOpen={isOpenModalActOnBehalf}
        onClose={() => setIsOpenModalActOnBehalf(false)}
      />
      <UptimeGeneralDialog
        title={t('topNav:confirmationSession.title')}
        content={
          <StyledDialogContent>
            {parse(
              t('topNav:confirmationSession:content', {
                clockAlertOutlineIcon,
                resultCountDown,
                minutesAndSeconds,
                continueText,
                signOutText,
              }),
            )}
          </StyledDialogContent>
        }
        isOpen={isIdlePrompt}
        showComment={false}
        buttonSubmit={buttonsAction}
        deviders={false}
        headerBackgroundDefault={false}
        cancelLabel={t('topNav:confirmationSession.cancelLabel')}
        hideButtonCancel={true}
        commonStyles={{ width: '346px' }}
        hideCloseIcon
        justifyContentAction="center"
        justifyContentTitle="center"
      />
      <UptimeGeneralDialog
        title={t('topNav:dashboard.dialogTitle')}
        content={
          <StyledDialogContent>
            <UptimeTextbox
              name="name"
              label={t('topNav:dashboard.dashboardName')}
              placeholder={t('topNav:dashboard.dashboardNamePlaceHolder')}
              boldLabel
              labelSize="small"
              value={customDashboardName}
              onChange={(e: any) => {
                setCustomDashboardName(e.target.value);
                setCustomDashboardFormError((prev) => ({...prev,name:false}));
              }}
              fullWidth
              required
              sx={{ paddingBottom: '16px' }}
              error={customDashboardFormError.name}
              textboxToolTip={t('topNav:dashboard.dialogTitle')}
            />
            <UptimeTextbox
              name="url"
              label={t('topNav:dashboard.embedUrl')}
              placeholder={t('topNav:dashboard.embedUrlPlaceHolder')}
              boldLabel
              labelSize="small"
              value={customDashboardUrl}
              onChange={(e: any) => {
                setCustomDashboardUrl(e.target.value);
                setCustomDashboardFormError((prev) => ({...prev,url:false}));
              }}
              fullWidth
              required
              error={customDashboardFormError.url}
              textboxToolTip={t('topNav:dashboard.embedUrl')}
            />
          </StyledDialogContent>
        }
        isOpen={openAddCustomDashboardDialog}
        showComment={false}
        buttonSubmit={customeDashboardButtonsAction}
        deviders={false}
        headerBackgroundDefault={false}
        cancelLabel={t('topNav:confirmationSession.cancelLabel')}
        hideButtonCancel={true}
        hideCloseIcon
        justifyContentAction="center"
        justifyContentTitle="center"
      />
      <StyleOutageNotification>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Slide}
        />
      </StyleOutageNotification>
      {/* Mobile Navigation Menu */}
      <MobileNavMenu
        isOpen={isMobileNavMenuOpen}
        manageItems={isAuthenticated ? menuItems : []}
        locale={topNav}
        onClickNavMenu={onItemClick}
        isAuthenticated={isAuthenticated}
        oidcAuthen={oidcAuthen}
        {...sharedProps}
      />
      <PunchOutModal
        isModalOpen={isPunchOutModalOpen}
        setIsModalOpen={setIsPunchOutModalOpen}
        title={t('punchOutModal.title', { portalName: generalConfig?.portalName || PORTAL_NAME })}
        message={punchOutModalContent.message}
        url={punchOutModalContent.url}
      />

      <UptimeTopNav
        logoImg={generalConfig?.staticImage?.logo}
        menuItems={isAuthenticated ? menuItems : []}
        configs={{ sticky: stickyMenu, homeIcon }}
        onClickBtnMenu={onMenuClick}
        onClickBtnLogo={() => {
          if(dataUser?.lockedOut) return;
          history.push({ pathname: HomePath });
        }}
        location={location}
        onItemClick={onItemClick}
        locale={{...topNav, ...homeAccessibilityTranslation}}
        globalSearchProps={{
          isLastWorkingDay: isLastWorkingDay,
          isNewJoiner: isNewJoiner,
          isNewJoinerLoading: isNewJoinerLoading,
          pushToHistory: pushToHistory,
          isUnderKnowledgePage:
            location.pathname.includes(GetSupportPath) ||
            location.pathname.includes(GlobalSearchPath),
          initialKeywords: keywords,
          onSearch: handleKBSearch,
          hasAnimation: true,
          homeAccessibilityTranslation: homeAccessibilityTranslation,
          placeholder: isGlobalSearchEnabled
            ? globalSearchPlaceHolder
            : knowledgeSearchPlaceHolder,
        }}
        userData={dataUser}
        handleOpenSubmenu={handleOpenSubmenu}
        portalName={PORTAL_NAME}
      >
        {isMarketplace && isMarketplaceEnabled && isSupportCountry && (
          <StyledBadge tabIndex={0} badgeContent={cart?.items?.length} color="error">
            <UptimeMarketPlace.IconButton
              icon={ShoppingCartIcon}
              id="btn-topnav-shopping_cart"
              onClick={() => history.push({ pathname: ShoppingCartPath })}
              aria-label={homeAccessibilityTranslation?.shoppingCartIcon}
            />
          </StyledBadge>
        )}
        {generalConfig?.cart?.enabled && (
          <StyledCart>  
              <UptimeMarketPlace.IconButton
                icon={ShoppingCartIcon}
                onClick={() => window.open(generalConfig?.cart?.url, '_blank')}
              />
          </StyledCart>
        )}
        {(breakpoint >= Breakpoint.md || !isMarketplace) && !isNewJoiner && !isLastWorkingDay &&(
          <Notification />
        )}
        {/* <div className="lang-block">
              <ContentLanguageSelector />
            </div> */}
          {isAuthenticated && (
            <>
              <Box position="relative" ml="15px">
                <UserSection
                  isMarketplace={isMarketplace}
                  openOnBehalfModal={() => setIsOpenModalActOnBehalf(true)}
                  isAuthenticated={isAuthenticated}
                  oidcAuthen={oidcAuthen}
                />
              </Box>
            </>
          )}
        </UptimeTopNav>
        <>{renderIndicator()}</>
      </StyledTopnavWrapper>
    </MarketplaceThemeProvider>
  );
};

export default TopNav;
